/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { Input, Table, Button, Select, Tag, Dropdown, Space, message, Avatar } from 'antd';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import moment from 'moment';
import { ExportCsv, ExportPdf } from '@material-table/exporters';
import { DownloadOutlined, DownOutlined } from '@ant-design/icons';

import FormDialog from './FormDialog'
import { TableWrapper } from '../../../container/styled';
import { Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import { CompSelector, ImagePreview } from '../../common';
import { API_ENDPOINT, CARD_STATUS_COLORS, CARD_STATUSES } from '../../../config/config';
import { themeColor } from '../../../config/theme/themeVariables';

const { Option } = Select;

function DataTable() {
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [busy, setBusy] = useState(false);
  const [cardStatus, setCardStatus] = useState(-1);
  const [reload, setReload] = useState(false);
  const [compID, setCompID] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]); // State to store selected rows
  const [showChangeStatus, setShowChangeStatus] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/e-card/query', {
        page: currentPage,
        pageSize,
        search,
        card_status: cardStatus,
        comp_id: compID
      });
      const { data, total } = response.data;
      setTableData(data);
      setTotalRows(total);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleExportCsv = () => {
    const formattedData = tableData.map((item) => {
      return ({
        ...item,
        created_at: moment(item.created_at).format('DD-MM-YYYY hh:mm a'),
      })
    });

    const tCols = [];
    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportCsv(tCols, formattedData, `Employees_${moment().format('DD-MM-YYYY')}`);
  };

  const handleExportPdf = () => {
    const formattedData = tableData.map((item) => {
      return ({
        ...item,
        created_at: moment(item.created_at).format('DD-MM-YYYY hh:mm a'),
      })
    });

    const tCols = [];
    TableColumns.forEach(item => { if (item.export) tCols.push(item) })
    ExportPdf(tCols, formattedData, `Employees_${moment().format('DD-MM-YYYY')}`);
  };

  useEffect(() => {
    fetchTableData();
    if (reload) setReload(false)
  }, [currentPage, pageSize, search, reload, compID]);

  const exportMenuItems = [
    {
      label: 'Export CSV',
      key: 1,
      icon: <DownloadOutlined />,
    },
    {
      label: 'Export PDF',
      key: 2,
      icon: <DownloadOutlined />,
    },
  ];

  const handleExportMenuClick = (event) => {
    let { key } = event;
    key = Number(key)
    if (key === 1) {
      handleExportCsv();
    } else if (key === 2) {
      handleExportPdf();
    }
  };

  const handleChangeStatusClick = async (event) => {
    try {
      if (selectedRows.length > 0) {
        for (let x = 0; x < selectedRows.length; x += 1) {
          const item = selectedRows[x];
          if (Number(item.card_status) === CARD_STATUSES.IN_PROCESS) {
            return message.error('You cant change status of in-process printings')
          }
        }
        setShowChangeStatus(true)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
    }
  }

  const exportMenuProps = {
    items: exportMenuItems,
    onClick: handleExportMenuClick,
  };

  const TableColumns = [
    {
      title: '',
      dataIndex: 'profile_picture',
      key: 'profile_picture',
      field: 'profile_picture',
      export: false,
      onCell: () => ({ className: 'w-20 text-center' }),
      render: (profile_picture) => {
        return (<Avatar
          className='cursor-pointer'
          src={profile_picture ? `${API_ENDPOINT}/${profile_picture}` : require('../../../static/img/avatar/profileImage.png')}
          size={40}
          onClick={(event) => {
            if (profile_picture) {
              setProfilePicture(`${API_ENDPOINT}/${profile_picture}`)
              setIsImageModalOpen(true)
            } else {
              message.info('No profile image');
            }
          }}
        />)
      },
    },
    {
      title: 'Employee Name',
      dataIndex: 'name',
      key: 'name',
      field: 'name',
      export: true,
    },
    {
      title: 'EMP CNIC',
      dataIndex: 'emp_cnic',
      key: 'emp_cnic',
      field: 'emp_cnic',
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },

    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
      field: 'contact',
      onCell: () => ({ className: 'w-40 text-center' }),
      export: true,
    },
    {
      title: 'Company',
      dataIndex: 'comp_name',
      key: 'comp_name',
      field: 'comp_name',
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },
    {
      title: 'IsActive',
      dataIndex: 'is_active',
      key: 'is_active',
      field: 'is_active',
      onCell: () => ({ className: 'w-10' }),
      export: true,
      render: (is_active) => {
        let color = themeColor['danger-color']
        let lblStr = 'InActive';

        if (Boolean(is_active)) {
          lblStr = 'Active'
          color = themeColor['success-color']
        }

        return (
          <div className="flex justify-content-center">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'card_status',
      key: 'card_status',
      field: 'card_status',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (card_status) => {
        card_status = Number(card_status);
        try {
          const { color, label } = CARD_STATUS_COLORS[card_status]
          return (
            <div className="flex justify-content-center">
              <div className='taglist-wrap select-none'>
                <Tag color={color}>{label}</Tag>
              </div>
            </div>
          )
        } catch (error) {
          return <p>Undefined</p>
        }
      },
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRowsData) => {
      const finalArray = []
      selectedRowsData.map(item => {
        if (Number(item.card_status) === CARD_STATUSES.PENDING) {
          finalArray.push(item)
        }
      })
      setSelectedRows(selectedRowsData); // Update state with selected rows
    },
    getCheckboxProps: (record) => ({
      disabled: Number(record.card_status) !== CARD_STATUSES.PENDING, // Example for disabling rows
      name: record.name,
    }),
  };

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Employee e-Cards" routes={[]} />
      <Main>
        <ImagePreview
          visible={isImageModalOpen}
          imageSrc={profilePicture}
          onClose={() => {
            setProfilePicture(null)
            setIsImageModalOpen(false)
          }}
        />
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <Input
              className=" hover:drop-shadow-xl hover:border-solid hover:border-1 hover:border-blue-800 rounded-sm w-1/4"
              size='small'
              autoFocus
              placeholder="Search Anything"
              prefix={<UilSearch size={15} />}
              defaultValue={search}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <div className="flex space-x-2">
              <div className="min-w-60">
                <CompSelector onItemSelected={setCompID} placeholder='Filter By Company' defaultSize='small' />
              </div>

              <Select
                placeholder="Card Status"
                className='w-40'
                value={cardStatus}
                onChange={(value) => {
                  setCardStatus(value)
                  setTimeout(() => {
                    setReload(true)
                  }, 200);
                }}
              >
                {Object.entries({ ALL: -1, ...CARD_STATUSES }).map(([key, value], index) => (
                  <Option key={value} value={value}>
                    {key}
                  </Option>
                ))}
              </Select>

              <Dropdown menu={exportMenuProps}>
                <Button className='h-9'>
                  <Space>
                    Export Data
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
              <Button
                type="primary"
                disabled={selectedRows.length < 1}
                onClick={handleChangeStatusClick}>
                Change Status
              </Button>
            </div>
          </div>
          <div className="ninjadasj-datatable">
            <TableWrapper >
              <Table
                rowKey={(record) => `${record.id}`} // Generate a unique key for each row
                loading={busy}
                key={`${currentPage}-${pageSize}`} // Add a unique key to force re-render
                bordered
                virutal
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                dataSource={tableData}
                columns={TableColumns}
                rowSelection={{
                  type: 'checkbox', // or 'radio'
                  ...rowSelection,
                }}
              />
            </TableWrapper>
          </div>
        </div>
        {showChangeStatus && <FormDialog showDialog={() => setShowChangeStatus(false)} setReload={setReload} selectedRows={selectedRows} />}
      </Main>
    </>
  );
}

export default DataTable;
